import { Card, Container, Grid, Hidden, Stack, Typography, useTheme } from '@mui/material';
import Image from 'src/components/image';
import { useLocales } from 'src/locales';

function HomeTokenomics() {
  const theme = useTheme();
  const { t } = useLocales();

  return (
    <Container id="tokenomics">
      <Stack
        spacing={3}
        sx={{
          mb: { xs: 5, md: 10 },
        }}
      >
        <Typography variant="h2" sx={{ color: theme.palette.primary.main }} textTransform="uppercase">
          {t('walkup_lang_024')}
        </Typography>

        <Grid container spacing={{ xs: 2, md: 4 }}>
          <Grid item xs={12} md={4}>
            <Stack spacing={{ xs: 2, md: 4 }}>
              <Card
                sx={{
                  p: 4,
                  border: `2px solid ${theme.palette.primary.main}`,
                }}
              >
                <Typography variant="h5" fontWeight="400">
                  {t('walkup_lang_025')}
                </Typography>
              </Card>

              <Card sx={{ p: 4, border: `2px solid ${theme.palette.primary.main}` }}>
                <Typography variant="h5" fontWeight="400">
                  {t('walkup_lang_026')}
                </Typography>
              </Card>
            </Stack>
          </Grid>

          <Hidden mdDown>
            <Grid item xs={12} md={4}>
              <Stack height="100%" alignItems="center" justifyContent="center">
                <Stack
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    borderRadius: 999,
                    height: 180,
                    width: 180,
                  }}
                >
                  <Image src="./assets/images/coin/WUT.png" />
                </Stack>
              </Stack>
            </Grid>
          </Hidden>

          <Grid item xs={12} md={4}>
            <Stack height="100%" justifyContent="center">
              <Card sx={{ p: 4, border: `2px solid ${theme.palette.primary.main}` }}>
                <Typography variant="h5" fontWeight="400">
                  {t('walkup_lang_027')}
                </Typography>
              </Card>
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </Container>
  );
}

export default HomeTokenomics;
